---
title: MDX Test
author: Benjamin Noah Beal
date: 2024-99-99
---

## Text Styles

_Italic_ _Italic_

**Bold** **Bold**

**_BoldItalic_** **_BoldItalic_**

~~Strikethrough~~

## Links

[Github](https://github.com/bebeal)

## Images

![DuneImage](https://i.redd.it/swyv5mdb58nc1.jpg)

## Inline Code

Example: `const x = 5`

## CodeBlock

```
const test = () => {
  return "basic codeblock"
}
```

## Python CodeBlock

```python
def add(a, b):
    return a + b
```

## Blockquote

> > Once men turned their thinking over to machines in the hope that this would set them free.
>
> — Frank Herbert, Dune

## Headings

# H1

## H2

### H3

#### H4

##### H5

###### H6

## Divider

---

## Unordered List

- Item 1
- Item 2
  - Nested 1
  - Nested 2

## Ordered List

1. First
2. Second
3. Third

## Table

| HeaderA | HeaderB |
| ------- | ------- |
| Cell1   | Cell2   |

## Task List

- [x] Completed
- [ ] Pending

## Emoji

:thumbsup:

## Inline Math

Formula: $a^2 + b^2 = c^2$

## Block Math

$$
E = \frac{1}{2}mv^2 + q\phi + q\vec{v} \cdot \vec{A}
$$

## Colors

#ff0000

#00ff0080

## Autolinks

http://example.com
contact@email.com

## References

Reference[^1] and [^2] look like this.

[^1]: Reference1 footnote

[^2]: Reference2 footnote
